<template>
  <transition name="fade">
    <div v-if="post && !dontShow" class="bordered" :style="`background-image: url(${post.image_url})`">
      <div @click="closeBlogPost(), reportEvent('blog-post-popup-close', post)" class="close-button cursor-pointer">
        <i class="mdi mdi-close"></i>
      </div>
      <div class="bordered__container">
        <div class="content">
          <h4 class="blog__text">
          {{post.post_title}}
          </h4>
          <hr/>
          <p class="blog__content" style="display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{post.post_content}}</p>
        </div>
      </div>

      <nuxt-link :to="`/ev-blog/artikel/${post.post_name}`" @click.native="reportEvent('blog-post-popup-open', post)" class="blog__button pt-3 px-3">
        <span class="badge badge-pill badge-vergelijking badge-vergelijking--success">
          <span class="badge__text">Bekijk blogpost</span>
          <i class="mdi mdi-arrow-right"></i>
        </span>
      </nuxt-link>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['modelId'],
    data() {
      return {
        post: undefined,
        dontShow: false,
        test: undefined,
      }
    },
    async created() {
      await this.$axios.get(`/api-modelid/`, {
        params: {
          modelId: this.modelId
        }
      }).then(response => {
        this.post = response.data[0];
        if(this.post){
          this.post.post_content = this.removeTags(this.post.post_content)
        }
      })
    },
    methods: {
      removeTags(str) {
          if ((str===null) || (str===''))
              return false;
          else
              str = str.toString();
                
          // Regular expression to identify HTML tags in 
          // the input string. Replacing the identified 
          // HTML tag with a null string.
          return str.replace( /(<([^>]+)>)/ig, '');
      },
      reportEvent(event, post){
        this.$gtag('event', `clicked-on-${event}`, {
        event_category: 'Model Overview',
        event_label: post.post_name,
      });
      },
      closeBlogPost(){
        this.dontShow = true;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .badge-pill {
    width: 100%;

    &.badge-vergelijking {
      display: flex;
      justify-content: space-between;
      margin: 1px 3px;
      padding: 0;
      flex-direction: row;
      align-items: center;

      .badge__text {
        padding: 0 6px 0 12px;
      }

      .mdi {
        display: block;
        padding: 8px;
        margin: 3px;
        width: auto;
        background-color: #000;
        border-radius: 100%;
      }

      &.badge-vergelijking--success {
        background-color: lighten(#2ecc71, 5%);
        color: white;

        .mdi {
          font-size: 16px;
          color: white;
          background-color: darken(#2ecc71, 5%);
        }
      }

      &.badge-vergelijking--danger {
        background-color: lighten(#e74c3c, 10%);
        color: white;

        .mdi {
          color: white;
          background-color: #e74c3c;
        }
      }
    }


  }
  .close-button {
    position: absolute;
    right: 0;
    top: 0;
    background-color: black;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    margin-top: 6px;
    margin-right: 6px;
    i {
      font-weight: bold;
      font-size: 11px;
      color: white;
    }
  }
  .blog__text {
    font-weight: bold;
    margin: 0px;
    color: #666;
  }

  .blog__content {
    margin-bottom: 0;
  }

  .bordered {
    // position: fixed;
    // z-index: 1000;
    // bottom: 20px;
    // right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    padding: 12px;
    background-color: lighten(#2ecc71, 45%);
  }

  .bordered__container {
    h4{
      width: 90%;
    }
    width: 300px;
    border-radius: 8px 28px 8px 8px;
    background-size: 50% 50%;
    background-repeat: no-repeat;
    padding: 16px 14px;
    background-color: #fff;
    background:
		linear-gradient(225deg, transparent 10px, #c00 0) top right;
    background-image:
		radial-gradient(50px circle at 98% 2%, rgba(255,255,255,0) 16px, #fff 17px);
  }
</style>
